export { default as Toaster } from './Sonner.vue';
export { toast } from 'vue-sonner';

export class ToastError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ToastError';
  }
}
